import React, { createContext, useContext, useState } from "react";
import { loginUser, registerUser, getProfile } from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  const persistTokens = (data) => {
    localStorage.setItem("access_token", data.access);
    localStorage.setItem("refresh_token", data.refresh);
  };

  const login = async (username, password) => {
    const { data } = await loginUser({ username, password });
    persistTokens(data);
    // The login endpoint only returns tokens, so fetch the full profile
    // (including role/is_staff) right after, and use THAT to decide routing.
    const { data: profile } = await getProfile();
    localStorage.setItem("user", JSON.stringify(profile));
    setUser(profile);
    return profile;
  };

  const register = async (payload) => {
    const { data } = await registerUser(payload);
    persistTokens(data);
    if (data.user) {
      localStorage.setItem("user", JSON.stringify(data.user));
      setUser(data.user);
    }
    return data;
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
  };

  const isAdmin = !!(user && (user.is_superuser || user.role === "admin"));
  const isManager = !!(user && user.role === "manager");

  return (
    <AuthContext.Provider
      value={{
        user, login, register, logout, isAdmin, isManager,
        isAuthenticated: !!localStorage.getItem("access_token"),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
